module.exports = __webpack_public_path__ + "img/bg-medium.a4413ec6.svg";